import { ICellRendererParams } from 'ag-grid-enterprise';

export default (props: ICellRendererParams) => {
  const show: boolean = (props as any).show(props);

  return show ? (
    <a
      className="bix-link link_underline"
      href={(props as any).createFeedbackUrl(props.data)}
      onClick={() => (props as any).handleFeedbackClick(props.data)}>
      {(props as any).createContactLinkText(props.data)}
    </a>
  ) : null;
};
